export const MEDIA_TYPES = {
    HTML: 'HTML',
    PLAIN_TEXT: 'PLAIN_TEXT',
};

export const TEMPLATE_KINDS = {
    INTRODUCTION: 'INTRODUCTION',
    APPOINTMENT: 'APPOINTMENT',
    INVITATION: 'INVITATION',
    FOLLOW_UP: 'FOLLOW_UP',
    REFERRAL: 'REFERRAL',
    REVIEW: 'REVIEW',
    CUSTOM: 'CUSTOM',
    KMN_BROADCAST_CUSTOM: 'KMN_BROADCAST_CUSTOM',
    KMN_BROADCAST_APPOINTMENT: 'KMN_BROADCAST_APPOINTMENT',
    KMN_BROADCAST_REMINDER: 'KMN_BROADCAST_REMINDER',
    KMN_BROADCAST_FOLLOW_UP: 'KMN_BROADCAST_FOLLOW_UP',
    KMN_BROADCAST_DISCOUNT: 'KMN_BROADCAST_DISCOUNT',
    KMN_AUTOMATION_CUSTOM: 'KMN_AUTOMATION_CUSTOM',
    KMN_AUTOMATION_APPOINTMENT: 'KMN_AUTOMATION_APPOINTMENT',
    KMN_AUTOMATION_INVITE: 'KMN_AUTOMATION_INVITE',
    KMN_AUTOMATION_REVIEW: 'KMN_AUTOMATION_REVIEW',
    KMN_AUTOMATION_FOLLOW_UP: 'KMN_AUTOMATION_FOLLOW_UP',
};

export const KMN_BROADCAST_TEMPLATE_KINDS = [
    TEMPLATE_KINDS.KMN_BROADCAST_CUSTOM,
    TEMPLATE_KINDS.KMN_BROADCAST_APPOINTMENT,
    TEMPLATE_KINDS.KMN_BROADCAST_REMINDER,
    TEMPLATE_KINDS.KMN_BROADCAST_FOLLOW_UP,
    TEMPLATE_KINDS.KMN_BROADCAST_DISCOUNT,
];

export const KMN_AUTOMATION_TEMPLATE_KINDS = [
    TEMPLATE_KINDS.KMN_AUTOMATION_CUSTOM,
    TEMPLATE_KINDS.KMN_AUTOMATION_APPOINTMENT,
    TEMPLATE_KINDS.KMN_AUTOMATION_INVITE,
    TEMPLATE_KINDS.KMN_AUTOMATION_REVIEW,
    TEMPLATE_KINDS.KMN_AUTOMATION_FOLLOW_UP,
];

export const TEMPLATES_AUTOMATION_DEFAULTS = {
    defaultKeapMarketingNumberAutomationTemplates: [
        {
            id: 'defaultKeapMarketingNumberAutomation1',
            templateKind: TEMPLATE_KINDS.KMN_AUTOMATION_FOLLOW_UP,
            title: 'Check your email',
            content: 'Hi [[contact.first_name]]. I just sent DETAILS_ABOUT_WHAT_YOU_SENT to your email. Please take a look and let me know if you have any questions.',
        },
        {
            id: 'defaultKeapMarketingNumberAutomation2',
            templateKind: TEMPLATE_KINDS.KMN_AUTOMATION_REVIEW,
            title: 'Request a review',
            content: 'Hi [[contact.first_name]]. We’re always striving to improve, so we’d love to hear about your recent experience in a review. Thank you! (GOOGLE_REVIEW_LINK)',
        },
    ],
};

export const TEMPLATES_BROADCAST_DEFAULTS = {
    defaultKeapMarketingNumberBroadcastTemplates: [
        {
            id: 'defaultKeapMarketingNumberBroadcast1',
            templateKind: TEMPLATE_KINDS.KMN_BROADCAST_APPOINTMENT,
            title: 'Fill an appointment',
            content: 'Hi [[contact.first_name]]. I have an appointment opening today at XX:XX p.m. If you\'d like the spot, please book with me here: (INSERT BOOKING LINK)',
        },
        {
            id: 'defaultKeapMarketingNumberBroadcast2',
            templateKind: TEMPLATE_KINDS.KMN_BROADCAST_REMINDER,
            title: 'Business update',
            content: 'Hi [[contact.first_name]]. I just wanted to let you know that DETAILS OF YOUR UPDATE. Please contact me at (XXX) XXX-XXXX if you have questions.',
        },
        {
            id: 'defaultKeapMarketingNumberBroadcast3',
            templateKind: TEMPLATE_KINDS.KMN_BROADCAST_FOLLOW_UP,
            title: 'Event reminder',
            content: 'Hi [[contact.first_name]]. Just a reminder that EVENT NAME is starting at EVENT TIME. Please join us here: (INSERT_EVENT_LINK)',
        },
        {
            id: 'defaultKeapMarketingNumberBroadcast4',
            templateKind: TEMPLATE_KINDS.KMN_BROADCAST_DISCOUNT,
            title: 'Special offer',
            content: 'I’m offering a XX% discount DURING THIS TIME on DISCOUNTED PRODUCT OR SERVICE. Simply enter PROMO CODE at checkout.',
        },
    ],
};
